function Projects() {
  return (
    <div className="projects-section">
      <h2 className="section-title">Featured Projects</h2>
      <div className="projects-grid">
        <div className="project-card">
          <div className="project-header">
            <h3 className="project-title">Cosmoscape</h3>
            <div className="project-badges">
              <span className="badge">React</span>
              <span className="badge">TypeScript</span>
              <span className="badge">Node/Express</span>
              <span className="badge">flux schnell AI Model</span>
            </div>
          </div>
          <p className="project-description">
            A full-stack web application showcasing modern development
            practices. I built the app as I'm internested in art and astronomy,
            but i don't have the capacity to paint or draw well. The platform
            combines a React and TypeScript frontend with a Node.js/Express
            backend, utilizing PostgreSQL for data persistence and Bunny.net for
            efficient content delivery. It demonstrates advanced full-stack
            architecture, RESTful API design, and seamless integration of
            multiple technologies to create an engaging user experience.
          </p>
          <div className="project-links">
            <a
              href="https://cosmo-scape.com/"
              className="project-link-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Website
            </a>
          </div>
        </div>

        <div className="project-card">
          <div className="project-header">
            <h3 className="project-title">Live Weather</h3>
            <div className="project-badges">
              <span className="badge">React</span>
              <span className="badge">TypeScript</span>
              <span className="badge">TailwindCSS</span>
              <span className="badge">OpenWeather API</span>
            </div>
          </div>
          <p className="project-description">
            A responsive weather application that provides real-time weather
            information for any location worldwide. Built with React and
            TypeScript for type safety and maintainability, the app features a
            clean, modern UI using Tailwind CSS. It integrates with the
            OpenWeather API to deliver current conditions, forecasts, and
            detailed weather metrics. The application demonstrates efficient API
            integration, state management, and responsive design principles.
          </p>
          <div className="project-links">
            <a
              href="https://live-weather-api-calls.netlify.app/"
              className="project-link-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Website
            </a>
            <a
              href="https://github.com/snoberyman/weather-app"
              className="project-link-btn secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
          </div>
        </div>

        <div className="project-card">
          <div className="project-header">
            <h3 className="project-title">TaskStorm</h3>
            <div className="project-badges">
              <span className="badge">Python/Flask</span>
              <span className="badge">MongoDB</span>
              <span className="badge">GraphQL</span>
              <span className="badge">llama-3-8b</span>
            </div>
          </div>
          <p className="project-description">
            I wanted to create a task management application that leverages AI
            to help users organize and prioritize their tasks automatically.
            TaskStorm is built with Python and Flask for the backend, utilizing
            GraphQL for efficient data querying. The application integrates the
            llama-3-8b model to analyze user input and set priorities for tasks
            automatically. In the beginning I used Mistral 7B locally on my
            graphics card, but later switched to llama-3-8b via API for easier
            deployment. The project showcases advanced backend development, AI
            integration, and modern API design.
          </p>
          <div className="project-links">
            <a
              href="https://task-storm.netlify.app/"
              className="project-link-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Live Demo
            </a>
            <a
              href="https://github.com/snoberyman/task-storm"
              className="project-link-btn secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
